const InViewport = () => {
  $.fn.isInViewport = function () {
    const elementTop = $(this).offset().top;
    const elementBottom = elementTop + $(this).outerHeight();
    const viewportTop = $(window).scrollTop();
    const viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  const checkInViewport = (selector, animationClass) => {
    $(selector).each(function() {
      if ($(this).isInViewport()) {
        $(this).addClass(animationClass);
      }
    });
  };

  // Check elements on page load
  checkInViewport('.js-fade-in-up', 'o-fade-in-up');
  checkInViewport('.js-fade-in', 'o-fade-in');
  checkInViewport('.js-image-reveal', 'o-image-reveal');

  // Check elements on scroll
  $(window).on('scroll', function() {
    checkInViewport('.js-fade-in-up', 'o-fade-in-up');
    checkInViewport('.js-fade-in', 'o-fade-in');
    checkInViewport('.js-image-reveal', 'o-image-reveal');
  });
};

export { InViewport };